import client from '/src/services/client.js';

export default {
    getPermissions: () => client.get('admin/permissions'),
    getRoles: () => client.get('admin/roles'),
    createRole: (data) => client.post('admin/roles', data),
    updateRole: (id, data) => client.put(`admin/roles/${id}`, data),
    deleteRole: (id) => client.delete(`admin/roles/${id}`),

    getUserRoles: (userId) => client.get(`administration/user/${userId}/roles`),
    assignUserRoles: (userId, role_ids) => client.put(`administration/user/${userId}/roles`, { role_ids }),
}
